import React from 'react';

import { FormControl, FormHelperText, MenuItem, Select } from '@material-ui/core';
import Remove from '@material-ui/icons/Remove';
import { MTableEditField } from 'material-table';

export {
  editComponentDefault,
  editLookupBasedOnParentLookup,
  renderValueOrRemoveIcon,
};

function editComponentDefault(props) {
  return <MTableEditField {...props} />;
}

function editLookupBasedOnParentLookup({ error, helperText, ...props }, parentName) {
  const { columnDef, onChange, rowData = {}, value } = props;

  const parentValue = rowData[parentName];
  const lookup = columnDef.lookup[parentValue] ?? [];

  return (
    <FormControl error={Boolean(error)}>
      <Select
        {...props}
        SelectDisplayProps={{ 'aria-label': columnDef.title }}
        onChange={event => onChange(event.target.value)}
        style={{ fontSize: 13 }}
        value={value ?? ''}
      >
        {lookup.map(key => (
          <MenuItem key={key} value={key}>
            {key}
          </MenuItem>
        ))}
      </Select>
      {Boolean(helperText) && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}

function renderValueOrRemoveIcon(rowData, name) {
  const value = rowData && rowData[name];

  if (value) {
    return value;
  }

  return <Remove />;
}
